import createConfigurableObject from '../../../../utils/configurationObject';

import { CYCLE_LOST_AND_FOUND_ROUTE, label, permission } from '../lostAndFoundPage';

export default {
    name: 'lostAndFoundTab',
    before: ['cycleCount'],
    after: [],
    setup: (app) => {
        app.cycleCountTabs = app.cycleCountTabs || createConfigurableObject();
        app.cycleCountTabs.addItem('cycleCountLostAndFoundGrid', {
            id: 'cycleCountLostAndFoundGrid',
            label,
            link: CYCLE_LOST_AND_FOUND_ROUTE,
            permission,
            order: 11,
        });
    },
};
